<template>
  <div id="app">
  	<Vheader></Vheader>
   <router-view  :key="key"/>
    <Vfooter></Vfooter>
  </div>
</template>

<script>
	import Vheader from './components/header'
	import Vfooter from './components/footer'
export default {
  name: 'app',
  components : {
  	Vheader,
  	Vfooter
  },
  computed: {
    key() {
        return this.$route.name !== undefined? this.$route.name + +new Date(): this.$route + +new Date()
    }
 }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue